export const getPrefix = (text: string) =>
  typeof text === "string" && text.length >= 3 ? text.slice(0, -3) : "";
